import React from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
// import { ChipCard } from 'assets/icons/circles/ChipCard'
import PageLayout from 'common/Layout/Page/PageLayout'

// import { ESim } from '../../assets/icons/circles/eSIM'
import PaymentTable from '../components/PaymentTable'

let toggledWarningFromPrevLocation = false

interface LocationState {
  reason?: string | undefined
}

export default function PaymentManagementPage() {
  // reads the redirect error and toasts it to the client
  const location = useLocation()
  const state = location.state as LocationState
  if (state?.reason && !toggledWarningFromPrevLocation) {
    toggledWarningFromPrevLocation = true
    toast.error(state.reason)
    delete state.reason
  }

  return (
    <PageLayout header='Manage Payments'>
      <PaymentTable />
    </PageLayout>
  )
}
